import { ITransmittalTypeOption } from './transmittal.models';

export enum ETransmittalType {
  ICE = 'ICE',
  REVIEWER = 'REVIEWER',
  SITE = 'SITE',
  DESIGNER = 'DESIGNER',
}

export const TransmittalTypeOptionDT: ITransmittalTypeOption = {
  code: ETransmittalType.DESIGNER,
  name: 'Designer',
  formName: 'Designer Transmittal',
};

export const TransmittalTypeOptionST: ITransmittalTypeOption = {
  code: ETransmittalType.SITE,
  name: 'Site',
  formName: 'Site Transmittal',
};

export const TransmittalTypeOptionIceT: ITransmittalTypeOption = {
  code: ETransmittalType.ICE,
  name: 'Checker',
  formName: 'Checker Transmittal',
};

export const TransmittalTypeOptionLir: ITransmittalTypeOption = {
  code: ETransmittalType.REVIEWER,
  name: 'Lambeth Independent Review',
  formName: 'Lambeth Independent Review',
};

export const TransmittalTypeOptions: ITransmittalTypeOption[] = [
  TransmittalTypeOptionDT,
  TransmittalTypeOptionST,
  TransmittalTypeOptionIceT,
  TransmittalTypeOptionLir,
];

export enum ETransmittalStatus {
  DRAFT = 'DRA',
  APPROVED = 'APP',
  PENDING_FOR_RFC = 'Pending RFC',
}

export const TRANSMITTAL_ITEM_ACCEPTED_FILES = 'application/pdf';
